/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './color-picker.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from 'ngx-color-picker/dist/lib/helpers';
import * as i3 from '@angular/common';
import * as i4 from 'ngx-color-picker/dist/lib/color-picker.component';
import * as i5 from 'ngx-color-picker/dist/lib/color-picker.service';
const styles_ColorPickerComponent:any[] = [i0.styles];
export const RenderType_ColorPickerComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ColorPickerComponent,data:{}});
function View_ColorPickerComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'div',([] as any[]),
      [[8,'className',0],[4,'top','px']],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'arrow arrow-',_co.cpPosition,'');
    const currVal_1:any = _co.arrowTop;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
function View_ColorPickerComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'div',[['style',
      'height: 18px;']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_ColorPickerComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'input',[['max',
      '1'],['min','0'],['pattern','[0-9]+([\\.,][0-9]{1,2})?'],['step','0.1'],['type',
      'number']],[[8,'value',0]],[[(null as any),'newValue'],[(null as any),'input']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).changeInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('newValue' === en)) {
          const pd_1:any = ((<any>_co.setA($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i2.TextDirective,
      ([] as any[]),{rg:[0,'rg']},{newValue:'newValue'})],(_ck,_v) => {
    const currVal_1:any = 1;
    _ck(_v,1,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.hslaText.a;
    _ck(_v,0,0,currVal_0);
  });
}
function View_ColorPickerComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['A']))],(null as any),(null as any));
}
function View_ColorPickerComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'input',[['max',
      '1'],['min','0'],['pattern','[0-9]+([\\.,][0-9]{1,2})?'],['step','0.1'],['type',
      'number']],[[8,'value',0]],[[(null as any),'newValue'],[(null as any),'input']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).changeInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('newValue' === en)) {
          const pd_1:any = ((<any>_co.setA($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i2.TextDirective,
      ([] as any[]),{rg:[0,'rg']},{newValue:'newValue'})],(_ck,_v) => {
    const currVal_1:any = 1;
    _ck(_v,1,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.rgbaText.a;
    _ck(_v,0,0,currVal_0);
  });
}
function View_ColorPickerComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['A']))],(null as any),(null as any));
}
function View_ColorPickerComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'div',[['class',
      'preset-color']],[[4,'backgroundColor',(null as any)]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.setColorFromString(_v.context.$implicit)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any)))],(null as any),(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,0,0,currVal_0);
  });
}
function View_ColorPickerComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),9,'div',[['class',
      'preset-area']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n       '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),0,'hr',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n\n       '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),1,'div',[['class','preset-label']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(5,(null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n\n       '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ColorPickerComponent_8)),
      i1.ɵdid(8,802816,(null as any),0,i3.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.cpPresetColors;
    _ck(_v,8,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.cpPresetLabel;
    _ck(_v,5,0,currVal_0);
  });
}
function View_ColorPickerComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'button',[['type',
      'button']],[[8,'className',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.oKColor()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(1,(null as any),['','']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.cpOKButtonClass,'');
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = _co.cpOKButtonText;
        _ck(_v,1,0,currVal_1);
      });
}
function View_ColorPickerComponent_11(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'button',[['type',
      'button']],[[8,'className',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.cancelColor()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(1,(null as any),['','']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.cpCancelButtonClass,'');
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = _co.cpCancelButtonText;
        _ck(_v,1,0,currVal_1);
      });
}
function View_ColorPickerComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'button-area']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ColorPickerComponent_10)),i1.ɵdid(3,16384,
          (null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ColorPickerComponent_11)),
      i1.ɵdid(6,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.cpOKButton;
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.cpCancelButton;
        _ck(_v,6,0,currVal_1);
      },(null as any));
}
export function View_ColorPickerComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{hueSlider:0}),i1.ɵqud(402653184,2,{alphaSlider:0}),
      i1.ɵqud(402653184,3,{dialogElement:0}),(_l()(),i1.ɵeld(3,0,[[3,0],['dialogPopup',
          1]],(null as any),121,'div',[['class','color-picker']],[[8,'hidden',0],[4,
          'visibility',(null as any)],[4,'height','px'],[4,'width','px'],[4,'top',
          'px'],[4,'left','px'],[4,'position',(null as any)]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ColorPickerComponent_1)),
      i1.ɵdid(6,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),
      (_l()(),i1.ɵeld(8,0,(null as any),(null as any),4,'div',[['class','saturation-lightness']],
          [[4,'background-color',(null as any)]],[[(null as any),'newValue'],[(null as any),
              'mousedown'],[(null as any),'touchstart']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.ColorPickerComponent = _v.component;
            if (('mousedown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,9).start($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchstart' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,9).start($event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('newValue' === en)) {
              const pd_2:any = ((<any>_co.setSaturationAndBrightness($event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(9,16384,(null as any),0,i2.SliderDirective,
          [i1.ElementRef],{rgX:[0,'rgX'],rgY:[1,'rgY']},{newValue:'newValue'}),(_l()(),
          i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(11,0,(null as any),
          (null as any),0,'div',[['class','cursor']],[[4,'left','px'],[4,'top','px']],
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(14,0,(null as any),(null as any),26,'div',[['class','box']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(16,0,(null as any),
          (null as any),5,'div',[['class','left']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵeld(18,0,(null as any),(null as any),0,'div',[['class','selected-color-background']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(20,0,(null as any),
          (null as any),0,'div',[['class','selected-color']],[[4,'background-color',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵeld(23,0,(null as any),(null as any),16,'div',
          [['class','right']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ColorPickerComponent_2)),
      i1.ɵdid(26,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n            '])),
      (_l()(),i1.ɵeld(28,0,[[1,0],['hueSlider',1]],(null as any),4,'div',[['class',
          'hue']],(null as any),[[(null as any),'newValue'],[(null as any),'mousedown'],
          [(null as any),'touchstart']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i4.ColorPickerComponent = _v.component;
        if (('mousedown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,29).start($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchstart' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,29).start($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('newValue' === en)) {
          const pd_2:any = ((<any>_co.setHue($event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(29,16384,(null as any),0,i2.SliderDirective,
          [i1.ElementRef],{rgX:[0,'rgX']},{newValue:'newValue'}),(_l()(),i1.ɵted(-1,
          (null as any),['\n                '])),(_l()(),i1.ɵeld(31,0,(null as any),
          (null as any),0,'div',[['class','cursor']],[[4,'left','px']],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n            '])),(_l()(),i1.ɵted(-1,(null as any),['\n\n            '])),
      (_l()(),i1.ɵeld(34,0,[[2,0],['alphaSlider',1]],(null as any),4,'div',[['class',
          'alpha']],[[8,'hidden',0],[4,'background-color',(null as any)]],[[(null as any),
          'newValue'],[(null as any),'mousedown'],[(null as any),'touchstart']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:i4.ColorPickerComponent = _v.component;
        if (('mousedown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,35).start($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchstart' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,35).start($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('newValue' === en)) {
          const pd_2:any = ((<any>_co.setAlpha($event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(35,16384,(null as any),0,i2.SliderDirective,
          [i1.ElementRef],{rgX:[0,'rgX']},{newValue:'newValue'}),(_l()(),i1.ɵted(-1,
          (null as any),['\n                '])),(_l()(),i1.ɵeld(37,0,(null as any),
          (null as any),0,'div',[['class','cursor']],[[4,'left','px']],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n            '])),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),
      (_l()(),i1.ɵeld(42,0,(null as any),(null as any),28,'div',[['class','hsla-text']],
          [[8,'hidden',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(44,0,(null as any),
          (null as any),13,'div',[['class','box']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵeld(46,0,(null as any),(null as any),1,'input',[['max','360'],['min',
          '0'],['pattern','[0-9]*'],['type','number']],[[8,'value',0]],[[(null as any),
          'newValue'],[(null as any),'input']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i4.ColorPickerComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,47).changeInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('newValue' === en)) {
          const pd_1:any = ((<any>_co.setHue($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(47,16384,(null as any),0,i2.TextDirective,
          ([] as any[]),{rg:[0,'rg']},{newValue:'newValue'}),(_l()(),i1.ɵted(-1,(null as any),
          ['\n            '])),(_l()(),i1.ɵeld(49,0,(null as any),(null as any),1,
          'input',[['max','100'],['min','0'],['pattern','[0-9]*'],['type','number']],
          [[8,'value',0]],[[(null as any),'newValue'],[(null as any),'input']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:i4.ColorPickerComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,50).changeInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('newValue' === en)) {
              const pd_1:any = ((<any>_co.setSaturation($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(50,16384,(null as any),0,i2.TextDirective,
          ([] as any[]),{rg:[0,'rg']},{newValue:'newValue'}),(_l()(),i1.ɵted(-1,(null as any),
          ['\n            '])),(_l()(),i1.ɵeld(52,0,(null as any),(null as any),1,
          'input',[['max','100'],['min','0'],['pattern','[0-9]*'],['type','number']],
          [[8,'value',0]],[[(null as any),'newValue'],[(null as any),'input']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:i4.ColorPickerComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,53).changeInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('newValue' === en)) {
              const pd_1:any = ((<any>_co.setLightness($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(53,16384,(null as any),0,i2.TextDirective,
          ([] as any[]),{rg:[0,'rg']},{newValue:'newValue'}),(_l()(),i1.ɵted(-1,(null as any),
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_ColorPickerComponent_3)),i1.ɵdid(56,16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵeld(59,0,(null as any),(null as any),10,'div',
          [['class','box']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),
          i1.ɵeld(61,0,(null as any),(null as any),1,'div',([] as any[]),(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['H'])),(_l()(),i1.ɵeld(63,0,(null as any),(null as any),1,
          'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['S'])),(_l()(),i1.ɵeld(65,
          0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['L'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_ColorPickerComponent_4)),i1.ɵdid(68,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n\n    '])),(_l()(),i1.ɵeld(72,0,(null as any),(null as any),
          28,'div',[['class','rgba-text']],[[8,'hidden',0]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(74,0,(null as any),(null as any),13,'div',[['class','box']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(76,0,(null as any),
          (null as any),1,'input',[['max','255'],['min','0'],['pattern','[0-9]*'],
              ['type','number']],[[8,'value',0]],[[(null as any),'newValue'],[(null as any),
              'input']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.ColorPickerComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,77).changeInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('newValue' === en)) {
              const pd_1:any = ((<any>_co.setR($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(77,16384,(null as any),0,i2.TextDirective,
          ([] as any[]),{rg:[0,'rg']},{newValue:'newValue'}),(_l()(),i1.ɵted(-1,(null as any),
          ['\n            '])),(_l()(),i1.ɵeld(79,0,(null as any),(null as any),1,
          'input',[['max','255'],['min','0'],['pattern','[0-9]*'],['type','number']],
          [[8,'value',0]],[[(null as any),'newValue'],[(null as any),'input']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:i4.ColorPickerComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,80).changeInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('newValue' === en)) {
              const pd_1:any = ((<any>_co.setG($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(80,16384,(null as any),0,i2.TextDirective,
          ([] as any[]),{rg:[0,'rg']},{newValue:'newValue'}),(_l()(),i1.ɵted(-1,(null as any),
          ['\n            '])),(_l()(),i1.ɵeld(82,0,(null as any),(null as any),1,
          'input',[['max','255'],['min','0'],['pattern','[0-9]*'],['type','number']],
          [[8,'value',0]],[[(null as any),'newValue'],[(null as any),'input']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:i4.ColorPickerComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,83).changeInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('newValue' === en)) {
              const pd_1:any = ((<any>_co.setB($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(83,16384,(null as any),0,i2.TextDirective,
          ([] as any[]),{rg:[0,'rg']},{newValue:'newValue'}),(_l()(),i1.ɵted(-1,(null as any),
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_ColorPickerComponent_5)),i1.ɵdid(86,16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵeld(89,0,(null as any),(null as any),10,'div',
          [['class','box']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),
          i1.ɵeld(91,0,(null as any),(null as any),1,'div',([] as any[]),(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['R'])),(_l()(),i1.ɵeld(93,0,(null as any),(null as any),1,
          'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['G'])),(_l()(),i1.ɵeld(95,
          0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['B'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_ColorPickerComponent_6)),i1.ɵdid(98,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n\n    '])),(_l()(),i1.ɵeld(102,0,(null as any),(null as any),
          13,'div',[['class','hex-text']],[[8,'hidden',0]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(104,0,(null as any),(null as any),4,'div',[['class','box']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(106,0,
          (null as any),(null as any),1,'input',([] as any[]),[[8,'value',0]],[[(null as any),
              'newValue'],[(null as any),'input']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.ColorPickerComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,107).changeInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('newValue' === en)) {
              const pd_1:any = ((<any>_co.setHex($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(107,16384,(null as any),0,i2.TextDirective,
          ([] as any[]),(null as any),{newValue:'newValue'}),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),
          i1.ɵeld(110,0,(null as any),(null as any),4,'div',[['class','box']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n            '])),(_l()(),i1.ɵeld(112,0,(null as any),(null as any),
          1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['Hex'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),(_l()(),i1.ɵeld(117,0,(null as any),
          (null as any),0,'div',[['class','type-policy']],(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.ColorPickerComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.formatPolicy()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ColorPickerComponent_7)),
      i1.ɵdid(120,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ColorPickerComponent_9)),
      i1.ɵdid(123,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i4.ColorPickerComponent = _v.component;
    const currVal_7:any = (_co.cpDialogDisplay == 'popup');
    _ck(_v,6,0,currVal_7);
    const currVal_9:any = 1;
    const currVal_10:any = 1;
    _ck(_v,9,0,currVal_9,currVal_10);
    const currVal_14:any = (_co.cpAlphaChannel === 'disabled');
    _ck(_v,26,0,currVal_14);
    const currVal_15:any = 1;
    _ck(_v,29,0,currVal_15);
    const currVal_19:any = 1;
    _ck(_v,35,0,currVal_19);
    const currVal_23:any = 360;
    _ck(_v,47,0,currVal_23);
    const currVal_25:any = 100;
    _ck(_v,50,0,currVal_25);
    const currVal_27:any = 100;
    _ck(_v,53,0,currVal_27);
    const currVal_28:any = (_co.cpAlphaChannel !== 'disabled');
    _ck(_v,56,0,currVal_28);
    const currVal_29:any = (_co.cpAlphaChannel !== 'disabled');
    _ck(_v,68,0,currVal_29);
    const currVal_32:any = 255;
    _ck(_v,77,0,currVal_32);
    const currVal_34:any = 255;
    _ck(_v,80,0,currVal_34);
    const currVal_36:any = 255;
    _ck(_v,83,0,currVal_36);
    const currVal_37:any = (_co.cpAlphaChannel !== 'disabled');
    _ck(_v,86,0,currVal_37);
    const currVal_38:any = (_co.cpAlphaChannel !== 'disabled');
    _ck(_v,98,0,currVal_38);
    const currVal_41:any = (_co.cpPresetColors && _co.cpPresetColors.length);
    _ck(_v,120,0,currVal_41);
    const currVal_42:any = (_co.cpOKButton || _co.cpCancelButton);
    _ck(_v,123,0,currVal_42);
  },(_ck,_v) => {
    var _co:i4.ColorPickerComponent = _v.component;
    const currVal_0:boolean = !_co.show;
    const currVal_1:any = (_co.hidden? 'hidden': 'visible');
    const currVal_2:any = _co.cpHeight;
    const currVal_3:any = _co.cpWidth;
    const currVal_4:any = _co.top;
    const currVal_5:any = _co.left;
    const currVal_6:any = _co.position;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = _co.hueSliderColor;
    _ck(_v,8,0,currVal_8);
    const currVal_11:any = _co.slider.s;
    const currVal_12:any = _co.slider.v;
    _ck(_v,11,0,currVal_11,currVal_12);
    const currVal_13:any = _co.selectedColor;
    _ck(_v,20,0,currVal_13);
    const currVal_16:any = _co.slider.h;
    _ck(_v,31,0,currVal_16);
    const currVal_17:any = (_co.cpAlphaChannel === 'disabled');
    const currVal_18:any = _co.alphaSliderColor;
    _ck(_v,34,0,currVal_17,currVal_18);
    const currVal_20:any = _co.slider.a;
    _ck(_v,37,0,currVal_20);
    const currVal_21:any = (_co.format != 2);
    _ck(_v,42,0,currVal_21);
    const currVal_22:any = _co.hslaText.h;
    _ck(_v,46,0,currVal_22);
    const currVal_24:any = _co.hslaText.s;
    _ck(_v,49,0,currVal_24);
    const currVal_26:any = _co.hslaText.l;
    _ck(_v,52,0,currVal_26);
    const currVal_30:any = (_co.format != 1);
    _ck(_v,72,0,currVal_30);
    const currVal_31:any = _co.rgbaText.r;
    _ck(_v,76,0,currVal_31);
    const currVal_33:any = _co.rgbaText.g;
    _ck(_v,79,0,currVal_33);
    const currVal_35:any = _co.rgbaText.b;
    _ck(_v,82,0,currVal_35);
    const currVal_39:any = (_co.format != 0);
    _ck(_v,102,0,currVal_39);
    const currVal_40:any = _co.hexText;
    _ck(_v,106,0,currVal_40);
  });
}
export function View_ColorPickerComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'color-picker',
      ([] as any[]),(null as any),(null as any),(null as any),View_ColorPickerComponent_0,
      RenderType_ColorPickerComponent)),i1.ɵdid(1,4308992,(null as any),0,i4.ColorPickerComponent,
      [i1.ElementRef,i1.ChangeDetectorRef,i5.ColorPickerService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const ColorPickerComponentNgFactory:i1.ComponentFactory<i4.ColorPickerComponent> = i1.ɵccf('color-picker',
    i4.ColorPickerComponent,View_ColorPickerComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/src/$$_gendir/node_modules/ngx-color-picker/dist/lib/color-picker.component.ngfactory.ts